<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('safe.language') }}
      </div>
    </div>
    <div class="wrap_box">
      <div
        class="item"
        :class="{ 'is-selected': lang === 'en_us' }"
        @click="changeLang('en_us',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/en_us.png"></div>
          <div class="info">
            English
          </div>
        </div>
        <div
          v-if="lang=='en_us'"
          class="language-check"
        >
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'id_ind' }"
        @click="changeLang('id_ind',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/id_ind.png"></div>
          <div class="info">
            Indonesia
          </div>
        </div>
        <div
          v-if="lang=='id_ind'"
          class="language-check"
        >
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'zh_hk' }"
        @click="changeLang('zh_hk',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/es_spa.png"></div>
          <div class="info">
            Español
          </div>
        </div>
        <div
          v-if="lang=='zh_hk'"
          class="language-check"
        >
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'th_th' }"
        @click="changeLang('th_th',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/th_th.png"></div>
          <div class="info">
            ภาษาไทย
          </div>
        </div>
        <div
          v-if="lang=='th_th'"
          class="language-check"
        >
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'vi_vn' }"
        @click="changeLang('vi_vn',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/vi_vn.png"></div>
          <div class="info">
            Người việt nam
          </div>
        </div>
        <div
          v-if="lang=='vi_vn'"
          class="language-check"
        >
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'ja_jp' }"
        @click="changeLang('ja_jp',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ja_jp.png"></div>
          <div class="info">
            日本語
          </div>
        </div>
        <div
          v-if="lang=='ja_jp'"
          class="language-check"
        >
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'ko_kr' }"
        @click="changeLang('ko_kr',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ko_kr.png"></div>
          <div class="info">
            한국어
          </div>
        </div>
        <div
          v-if="lang=='ko_kr'"
          class="language-check"
        >
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'ms_my' }"
        @click="changeLang('ms_my',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ms_my.png"></div>
          <div class="info">
            Melayu
          </div>
        </div>
        <div
          v-if="lang=='ms_my'"
          class="language-check"
        >
          ✓
        </div>
      </div>
      <div
        class="item"
        :class="{ 'is-selected': lang === 'pt_br' }"
        @click="changeLang('pt_br',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/pt_br.png"></div>
          <div class="info">
            Brasil
          </div>
        </div>
        <div
          v-if="lang=='pt_br'"
          class="language-check"
        >
          ✓
        </div>
      </div>
<!--      <div
        class="item"
        :class="{ 'is-selected': lang === 'zh_cn' }"
        @click="changeLang('zh_cn',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/zh_cn.png"></div>
          <div class="info">
            简体中文
          </div>
        </div>
        <div
          v-if="lang=='zh_cn'"
          class="language-check"
        >
          ✓
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	import bsHeader from '../../components/bsHeader.vue'
	import {
		Toast
	} from 'vant'
	export default {
		name: "Language",
		components: {
			bsHeader
		},
		data() {
			return {
				lang:this.$i18n.locale||"en_us",
			};
		},
		created() {
		},
		mounted() {
		},
		methods: {
			changeLang(lang,event) {
				Toast.loading({
					// mask: true,
					duration: 200
				})
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				this.$router.go(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	// .red_top_bg {
	// 	// background: linear-gradient(90deg, #5b60df, #5b60df) !important;
	// }
	.wrap_box{
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 5px;
		width: 98%;
		margin: 5px auto;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #ECECEC;
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: bold;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
			.right{
				width: 20px;
				height: 20px;
				background: url(../images/user/arrow.png) no-repeat center center;
				background-size: 100% 100%;
			}
			.right_info{
				color: rgba(0,0,0,.6);
			}
			.tips{
				color: rgba(0,0,0,.6);
				margin-left: auto;
				margin-right: 4px;
				font-weight: normal;
			}
			.left{
				img{
					width: 33px;
					margin-top: 5px;
				}
			}
		}
	}

	.basic_wrap {
		min-height: 100vh;
		box-sizing: border-box;
		padding: 12px 18px 78px;
		background: #fbf9fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
	}

	.red_top_bg {
		height: 30px;
		margin-bottom: 12px;
		background: transparent;
	}

	.red_top_bg .big_tit {
		top: 5px;
		color: #111;
		font-size: 14px;
		line-height: 20px;
	}

	.red_top_bg .back_left {
		width: 24px;
		height: 24px;
		margin: 3px 0 0;
	}

	.wrap_box {
		width: 100%;
		margin: 0;
		padding: 0 14px;
		box-sizing: border-box;
		align-items: stretch;
		border-radius: 10px;
		background: #fff;
	}

	.wrap_box .item {
		width: 100%;
		height: 52px;
		box-sizing: border-box;
		padding: 0;
		align-items: center;
		color: #2d2433;
		font-size: 12px;
		font-weight: 500;
		line-height: 20px;
	}

	.wrap_box .item .info {
		color: #111;
	}

	.wrap_box .item.is-selected .info {
		color: #f8328c;
	}

	.wrap_box .language-check {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		width: 20px;
		height: 100%;
		color: #f8328c;
		font-size: 14px;
		line-height: 20px;
	}

	.wrap_box .item .left img {
		width: 28px;
		margin-top: 0;
	}

	.wrap_box .item .info {
		margin-left: 10px;
	}
</style>
